module.exports = __webpack_public_path__ + "img/img1.ecee49f8.jpg";